import { Accordion } from '@mantine/core'

import * as Types from '../../declarations'
import SectionHeader from './components/SectionHeader'
import HTMLContent from 'components/HTMLContent'

interface Props {
	trip: Types.DB.Models.TripAttributes
}

const FAQs = ({
	trip: {
		name,
		jsonData: { faqs, trekOrClimb },
	},
}: Props) => {
	if (!faqs) return <></>

	return (
		<div id="faqs-wrapper" className="spacing-between-sections-above">
			<SectionHeader
				title={`${name} questions`}
				subtitle={`What to know about ${
					trekOrClimb === Types.App.DataTypes.TrekOrClimb.TREK
						? 'trekking'
						: 'climbing'
				} ${name}`}
				section={Types.App.DataTypes.FeedbackSection.FAQs}
			/>
			<p>
				Common questions people have about this trek, if yours isn’t here - add
				it to get an answer.
			</p>

			<div id="faqs-items">
				<Accordion multiple={true}>
					{faqs.map((item, key) => {
						return (
							<Accordion.Item
								key={key}
								value={item.question}
								className="faqs-item"
							>
								<Accordion.Control>
									<h3 className="question">{item.question}</h3>
								</Accordion.Control>
								<Accordion.Panel>
									<HTMLContent html={item.answer}></HTMLContent>
								</Accordion.Panel>
							</Accordion.Item>
						)
					})}
				</Accordion>
			</div>
		</div>
	)
}

export default FAQs
